module.exports = "/static/media/lukas.08a751c7.jpg";